<script setup lang="ts">
    const open = ref<boolean>(false);
    const showModal = () => open.value = !open.value;

    // Handles close events
    const handleCloseEvent = () => {
        open.value = false;
    }

    defineExpose({
        showModal,
        open
    })

</script>

<template>
    <slot
        name="accessButton"
        :showModal="showModal"
    />

    <a-modal 
        :centered="true" 
        :width="560"
        :footer="null"
        v-model:open="open"
        @cancel="handleCloseEvent">

        <UserLoginForm
            v-if="open"
            type="modal"
            @closeEvent="handleCloseEvent"
        />
    </a-modal>
</template>